import { useDispatch } from 'react-redux'
import { TAppDispatch } from '../@types'

const useAppDispatch: () => TAppDispatch = useDispatch

export default useAppDispatch
